import "./styles.scss";
import logo from "../images/SRL_ID_Horiz_White_logo.png";

export default function Footer(props) {
  return (
    <div className="footerWrap">
      <footer className="footer">
        <div className="container container-large branding">
          <div className="row">
            <div className="col-sm-12 col-md-3">
              <a href="https://www.savetheredwoods.org/">
                <img
                  src={logo}
                  alt="Save the Redwoods League"
                  className="img-responsive"
                  width="185"
                  style={{ marginTop: '5px' }}
                />
              </a>
            </div>
            <div className="col-sm-12 col-md-9 donate">

                  <strong className='copyright'>
                      © 2026 Save the Redwoods League
                      </strong>
                      <br />
                      <p className='address-legal'>
                        <span>220 Montgomery Street, Suite 350,</span> <span>San Francisco, CA 94104</span> <span>| 415.362.2352</span><br />
                        <span>501(c)(3) nonprofit</span> <span>| Tax ID: 94-0843915</span> | Gifts are tax deductible to the fullest extent of the law
                    </p>
              <ul className="list-inline">
                <li>
                  <a
                    href="https://www.instagram.com/savetheredwoods/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">
                      Visit Instagram (opens new window)
                    </span>
                    <i className="fa fa-lg fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/SaveTheRedwoodsLeague"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">
                      Visit Facebook (opens new window)
                    </span>
                    <i
                      className="fa fa-lg fa-facebook-square"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/savetheredwoods/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">
                      Visit Twitter (opens new window)
                    </span>
                    <i
                      className="fa fa-lg fa-threads-square"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/user/savetheredwoods"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">
                      Visit Youtube (opens new window)
                    </span>
                    <i
                      className="fa fa-lg fa-youtube-square"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/save-the-redwoods-league"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sr-only">
                      Visit LinkedIn (opens new window)
                    </span>
                    <i
                      className="fa fa-lg fa-linkedin-square"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </footer>
    </div>
  );
}
